import React from 'react';
import { companyInfo } from '../data/content';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

export default function Contact() {
  return (
    <div className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-bold mb-12 text-center">Contact BlueFlow Plumbing</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h2 className="text-2xl font-bold mb-6">Get In Touch</h2>
            <p className="text-slate-600 mb-8">Whether you have a plumbing emergency, need a quote for an installation, or just have a question, our team is ready to help.</p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-50 text-primary rounded-full flex items-center justify-center shrink-0">
                  <SafeIcon name="Phone" className="text-xl" />
                </div>
                <div>
                  <h3 className="font-bold text-lg">Phone</h3>
                  <p className="text-slate-600">Main: <a href={`tel:${companyInfo.phone}`} className="text-primary hover:underline">{companyInfo.phone}</a></p>
                  <p className="text-sm text-red-500 font-semibold mt-1">24/7 Emergency Dispatch Available</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-50 text-primary rounded-full flex items-center justify-center shrink-0">
                  <SafeIcon name="Mail" className="text-xl" />
                </div>
                <div>
                  <h3 className="font-bold text-lg">Email</h3>
                  <a href={`mailto:${companyInfo.email}`} className="text-primary hover:underline">{companyInfo.email}</a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-50 text-primary rounded-full flex items-center justify-center shrink-0">
                  <SafeIcon name="MapPin" className="text-xl" />
                </div>
                <div>
                  <h3 className="font-bold text-lg">Office Address</h3>
                  <p className="text-slate-600">{companyInfo.address}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Form */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200">
            <h2 className="text-2xl font-bold mb-6">Send a Message</h2>
            <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
              <div>
                <input required type="text" placeholder="Your Name" className="w-full p-3 border border-slate-300 rounded-lg outline-none focus:border-primary" />
              </div>
              <div>
                <input required type="email" placeholder="Email Address" className="w-full p-3 border border-slate-300 rounded-lg outline-none focus:border-primary" />
              </div>
              <div>
                <textarea required rows="4" placeholder="How can we help?" className="w-full p-3 border border-slate-300 rounded-lg outline-none focus:border-primary"></textarea>
              </div>
              <Button type="submit" variant="primary" className="w-full">Send Message</Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}